import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppSettings } from "../../config/config";
import { map } from "rxjs/operators";
import { apiConstants } from "../constant/apiConstant";

@Injectable({ providedIn: 'root' })
export class NewLoginWithDomainVerificationServices {
  private url = AppSettings.API_ENDPOINT_V3;
  private URL = AppSettings.API_ENDPOINT;
  private verifySchoolDomainDetails = apiConstants.verifySchoolDomainDetails;
  private schoolDomainLoginWithOtpDetails =
    apiConstants.schoolDomainLoginWithOtp;
  private schoolDomainLoginWithPasswordDetails =
    apiConstants.schoolDomainLoginWithPassword;
  private verifyOtpForDomainLogin = apiConstants.verifyOtpForDomainLogin;
  private sendOtpForForgotPassword = apiConstants.sendOtpForForgotPassword
  private resetSchoolLoginPassword = apiConstants.resetPassword
  private staffLoginAPI =
  apiConstants.staffLogin;
  constructor(private http: HttpClient) { }
  headers: HttpHeaders;
  verifySchoolDomainDetailsApi(body: any) {
    return this.http
      .post(`${this.url}${this.verifySchoolDomainDetails}`, body, {
        headers: this.headers,
      })
      .pipe(map((res) => res));
  }

  schoolDomainLoginWithOtpApi(body: any) {
    return this.http
      .post(`${this.url}${this.schoolDomainLoginWithOtpDetails}`, body, {
        headers: this.headers,
      })
      .pipe(map((res) => res));
  }

  schoolDomainLoginWithPasswordApi(body: any) {
    return this.http.post(
      `${this.url}${this.schoolDomainLoginWithPasswordDetails}`,
      body,
      { headers: this.headers }
    );
  }

  verifyingOtpForDomainLoginApi(body: any) {
    return this.http
      .post(`${this.url}${this.verifyOtpForDomainLogin}`, body, {
        headers: this.headers,
      })
      .pipe(map((res) => res));
  }
  sendOtpForResetPassword(body : any){
    return this.http
    .post(`${this.url}${this.sendOtpForForgotPassword}`, body)
    .pipe(map((res) => res));
  }
  resetPassword(body : any){
    return this.http
    .put(`${this.url}${this.resetSchoolLoginPassword}`, body)
    .pipe(map((res) => res));
  }
  staffLoginApi(body: any) {
    return this.http.post(
      `${this.URL}${this.staffLoginAPI}`,
      body,
      { headers: this.headers }
    );
  }
}